import type { HeroFeedItem } from 'src/app/pages/promote/pageContext';

type Result = ModelHookResult<{
	amountFormatted: string;
	avatarUrl: string;
}>;

export function useHeroFeedItemPill(item: HeroFeedItem): Result {
	return {
		data: {
			amountFormatted:
				item.event.__typename === 'HeroFeedPromotionEvent' && item.event.amountLocalizedWithCurrency
					? item.event.amountLocalizedWithCurrency
					: '', // this is a fallback because the Query only returns promotions.
			avatarUrl: item.userPhoto || '',
		},
	};
}
